import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBird = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 411,
	height: 359,
	viewBox: "0 0 411 359",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_718_1094)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M209.19 358.3C298.936 358.3 371.69 285.546 371.69 195.8C371.69 106.054 298.936 33.3 209.19 33.3C119.444 33.3 46.6899 106.054 46.6899 195.8C46.6899 285.546 119.444 358.3 209.19 358.3Z",
				fill: "#EBF3FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M314.42 303.5H249.99C249.16 303.5 248.49 302.83 248.49 302C248.49 301.17 249.16 300.5 249.99 300.5H314.42C315.25 300.5 315.92 301.17 315.92 302C315.92 302.83 315.25 303.5 314.42 303.5Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M241.96 303.5H60.73C59.9 303.5 59.23 302.83 59.23 302C59.23 301.17 59.9 300.5 60.73 300.5H241.97C242.8 300.5 243.47 301.17 243.47 302C243.47 302.83 242.8 303.5 241.97 303.5H241.96Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M260.33 50.45C266.95 50.45 272.34 55.84 272.34 62.46V278.68C272.34 285.3 266.95 290.69 260.33 290.69H94.3601C87.7401 290.69 82.3501 285.3 82.3501 278.68V62.46C82.3501 55.84 87.7401 50.45 94.3601 50.45H260.34",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M260.33 50.45C266.95 50.45 272.34 55.84 272.34 62.46V278.68C272.34 285.3 266.95 290.69 260.33 290.69H94.36C87.74 290.69 82.35 285.3 82.35 278.68V62.46C82.35 55.84 87.74 50.45 94.36 50.45H260.34M260.33 37.63H94.35C80.64 37.63 69.52 48.75 69.52 62.46V278.68C69.52 292.39 80.64 303.51 94.35 303.51H260.33C274.04 303.51 285.16 292.39 285.16 278.68V62.46C285.16 48.75 274.04 37.63 260.33 37.63Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M150.47 25.03H203.66C220.7 25.03 234.54 38.87 234.54 55.91V58.7C234.54 61.84 231.99 64.4 228.84 64.4H125.28C122.14 64.4 119.58 61.85 119.58 58.7V55.91C119.58 38.87 133.42 25.03 150.46 25.03H150.47Z",
				fill: "#FFC700"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M177.07 0.309998C187.69 0.309998 196.31 8.93 196.31 19.55V30.24H157.83V19.55C157.83 8.93 166.45 0.309998 177.07 0.309998Z",
				fill: "#FFC700"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M177.07 24.5C180.958 24.5 184.11 21.3481 184.11 17.46C184.11 13.5719 180.958 10.42 177.07 10.42C173.182 10.42 170.03 13.5719 170.03 17.46C170.03 21.3481 173.182 24.5 177.07 24.5Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0_718_1094",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 119,
				y: 25,
				width: 116,
				height: 40,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M150.47 25.03H203.66C220.7 25.03 234.54 38.87 234.54 55.91V58.7C234.54 61.84 231.99 64.4 228.84 64.4H125.28C122.14 64.4 119.58 61.85 119.58 58.7V55.91C119.58 38.87 133.42 25.03 150.46 25.03H150.47Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				mask: "url(#mask0_718_1094)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M241.63 55.98H112.51V68.12H241.63V55.98Z",
					fill: "#FFB100"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M335.95 139.12C335.97 139.62 335.78 140.12 335.43 140.47L322.82 153.09C322.5 153.41 322.09 153.63 321.65 153.67C321.11 153.71 320.6 153.53 320.23 153.15L314.8 147.72C314.44 147.36 314.25 146.87 314.28 146.37C314.3 145.87 314.54 145.39 314.93 145.07C315.63 144.49 316.71 144.56 317.38 145.23L321.47 149.32C321.47 149.32 321.52 149.34 321.53 149.32L332.87 137.98C333.54 137.31 334.61 137.24 335.32 137.82C335.71 138.14 335.94 138.62 335.97 139.12H335.95Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.18 125.66C139.845 125.66 147.68 117.825 147.68 108.16C147.68 98.495 139.845 90.66 130.18 90.66C120.515 90.66 112.68 98.495 112.68 108.16C112.68 117.825 120.515 125.66 130.18 125.66Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 100.46H192.76",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 116.94H228.01",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.18 191.1C139.845 191.1 147.68 183.265 147.68 173.6C147.68 163.935 139.845 156.1 130.18 156.1C120.515 156.1 112.68 163.935 112.68 173.6C112.68 183.265 120.515 191.1 130.18 191.1Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 165.89H192.76",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 182.38H210.64",
				stroke: "#DCEBFE",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M130.18 256.54C139.845 256.54 147.68 248.705 147.68 239.04C147.68 229.375 139.845 221.54 130.18 221.54C120.515 221.54 112.68 229.375 112.68 239.04C112.68 248.705 120.515 256.54 130.18 256.54Z",
				fill: "#3F8BFD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 231.33H192.76",
				stroke: "#3F8BFD",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M162.62 247.82H228.01",
				stroke: "#3F8BFD",
				strokeWidth: 5,
				strokeMiterlimit: 3,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.02 109.32L128.38 113.68L137.55 104.51",
				stroke: "white",
				strokeWidth: 3.7,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.02 174.3L128.38 178.65L137.55 169.48",
				stroke: "white",
				strokeWidth: 3.7,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M124.02 240.23L128.38 244.58L137.55 235.41",
				stroke: "white",
				strokeWidth: 3.7,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.6902 169.29C21.7102 169.79 21.5202 170.29 21.1702 170.64L8.56017 183.26C8.24018 183.58 7.83017 183.8 7.39017 183.84C6.85017 183.88 6.34017 183.7 5.97017 183.32L0.540174 177.89C0.180174 177.53 -0.00982594 177.04 0.0201741 176.54C0.0401741 176.04 0.280174 175.56 0.670174 175.24C1.37017 174.66 2.45017 174.73 3.12017 175.4L7.21017 179.49C7.21017 179.49 7.26017 179.51 7.27017 179.49L18.6102 168.15C19.2802 167.48 20.3502 167.41 21.0602 167.99C21.4502 168.31 21.6802 168.79 21.7102 169.29H21.6902Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M278.97 1.69998C278.99 2.19998 278.8 2.69998 278.45 3.04998L265.84 15.67C265.52 15.99 265.11 16.21 264.67 16.25C264.13 16.29 263.62 16.11 263.25 15.73L257.82 10.3C257.46 9.93998 257.27 9.44998 257.3 8.94998C257.32 8.44998 257.56 7.96998 257.95 7.64998C258.65 7.06998 259.73 7.13998 260.4 7.80998L264.49 11.9C264.49 11.9 264.54 11.92 264.55 11.9L275.89 0.559976C276.56 -0.110024 277.63 -0.180024 278.34 0.399976C278.73 0.719976 278.96 1.19998 278.99 1.69998H278.97Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M410.35 95.27C410.39 96.04 410.09 96.8 409.55 97.35L390.17 116.73C389.68 117.22 389.05 117.56 388.37 117.62C387.55 117.69 386.76 117.4 386.19 116.82L377.84 108.47C377.29 107.92 377 107.16 377.04 106.39C377.08 105.62 377.44 104.89 378.04 104.4C379.12 103.51 380.77 103.61 381.8 104.64L388.09 110.93C388.09 110.93 388.16 110.96 388.19 110.93L405.61 93.51C406.64 92.48 408.28 92.38 409.37 93.27C409.97 93.77 410.33 94.49 410.37 95.27H410.35Z",
				fill: "#DCEBFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M314.17 303.33H208.6C206.73 303.33 205.22 301.82 205.22 299.95C205.22 298.08 206.73 296.57 208.6 296.57H314.17C316.04 296.57 317.55 298.08 317.55 299.95C317.55 301.82 316.04 303.33 314.17 303.33Z",
				fill: "#002F75"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M279.52 173.65H308.17V244.53C308.17 277.89 281.09 304.97 247.73 304.97H233.01V220.17C233.01 194.5 253.85 173.66 279.52 173.66V173.65Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M308.18 173.65H315.46C332.74 173.65 346.77 187.68 346.77 204.96C346.77 207.21 344.95 209.03 342.7 209.03H308.19V173.65H308.18Z",
				fill: "#FFC700"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M308.18 209.03H333.32C333.32 220.68 323.86 230.14 312.21 230.14H308.18V209.03Z",
				fill: "#FFB100"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M268.81 327.65L250.23 339.16C248.07 340.5 245.28 338.95 245.28 336.41V298.77H270.33V324.9C270.33 326.02 269.75 327.06 268.8 327.65H268.81Z",
				fill: "#6BA6FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M243.06 200.5C256.08 200.5 266.64 211.07 266.64 224.08V270.34C266.64 294.48 247.04 314.07 222.91 314.07C221.01 314.07 219.47 312.53 219.47 310.63V224.07C219.47 211.05 230.04 200.49 243.05 200.49L243.06 200.5Z",
				fill: "#9EC5FF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M229.33 166.55C229.33 176.6 237.48 184.74 247.52 184.74H255.1",
				stroke: "#6BA6FF",
				strokeWidth: 5.41,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M284.66 200.06C288.449 200.06 291.52 196.989 291.52 193.2C291.52 189.411 288.449 186.34 284.66 186.34C280.872 186.34 277.8 189.411 277.8 193.2C277.8 196.989 280.872 200.06 284.66 200.06Z",
				fill: "#002F75"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_718_1094",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 410.36,
			height: 358.3,
			fill: "white"
		})
	}) })]
});
export default SvgBird;
